import { createSelector } from "reselect";

export const selectUser = (state) => state.usuario;
export const selectVariablesUser = (state) => state.usuario?.variaveis;
export const selectVariablesGlobals = (state) =>
  state.usuario?.variaveis_globais;

export const selectUserStores = (state) => state.usuario?.lojas;

export const seletorUserWithStoreTotal = createSelector(
  selectUserStores,
  (stores) => {
    if (!stores) return [];
    const storeTotal = stores?.join(",");
    return [...stores, [storeTotal, "TODOS"]];
  }
);
